// import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { routers } from "@/routes";
import "../app/globals.css";
import { Toaster } from "sonner";
import * as Sentry from "@sentry/react";

const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

if (!isLocalhost) {
  Sentry.init({
    dsn: "https://007642260a35a7733b83dfdb971d91e7@sentry.me2.dev.br/3",
    sendDefaultPii: true
  });
}
ReactDOM.createRoot(document.getElementById("root")!).render(
  <>
    <RouterProvider router={routers} />
    <Toaster />
  </>
);
